import React from 'react'
import { Media, Modal, ModalBody, ModalHeader } from 'reactstrap'

const  ImgPopup = (props) => {
  const modalStyle = {
    borderBottom: "none",
    padding: "1rem 1rem 0 0"
  }

  const closeDiv = {
    maxWidth: "max-content",
    padding: "0.5rem",
    margin: "auto",
  }
  const close = {
    fontSize: "0.8rem",
    textDecoration: "underline",
    cursor: "pointer",
    marginBottom: "0"
  }
  return (
    <Modal isOpen={props.PopUpImg} toggle={props.toggleImgPopUp} 
      centered size="lg" style={!props?.isMobile ? {marginTop: "4rem"} : {}}>
    <ModalHeader style={modalStyle} toggle={props.toggleImgPopUp}></ModalHeader>
      <ModalBody className='text-center'>
        <div className='m-auto' style={{padding: "1rem"}}>
          <Media src={props.imgSrc} alt="alt-asset" className='w-100'/>
        </div>

        <div style={closeDiv}>
          <p style={close} className="text-secondary" onClick={props.toggleImgPopUp}>Close</p>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ImgPopup